module.exports = __webpack_public_path__ + "img/index_01.f43b170f.jpg";